import React from 'react';

import TrendingUp from '@olxbr/olx-icons/dist/System/TrendingUp';
import BarChart from '@olxbr/olx-icons/dist/System/BarChart';
import Rocket from '@olxbr/olx-icons/dist/System/Rocket';
import ReactMarkdown from 'react-markdown';

import { CheckItem } from './components/Cards/styles';

function getIcon(icon){
  switch (icon) {
    case 'TRENDING_UP':
      return TrendingUp
    case 'BAR_CHART':
      return BarChart
    case 'ROCKET':
      return Rocket
    default:
      return ''
  }
}

function buildCardsData(bundleValue, subscriptions) {

  let cards = subscriptions.filter((card)=> card.amount === bundleValue)
  
  cards = cards.map((card,index) => {
     let card_temp = {
        id: card.bundle.id?card.bundle.id:'',
        disabled: false,
        topSeller: index === 1?true:false,
        header: {
          title: card.bundle.header.title?card.bundle.header.title:'',
          icon: card.bundle.header.icon?getIcon(card.bundle.header.icon):'',
          description: card.bundle.header.description?card.bundle.header.description:'',
          price: card.totalPrice?card.totalPrice:'',
          bundleType: card.bundle.type?card.bundle.type:'',
        },
        info: [
          ...card.characteristics && card.characteristics.length > 0?card.characteristics.map((characteristic)=><CheckItem disabled={!characteristic.checkmark}><ReactMarkdown>{characteristic.text}</ReactMarkdown></CheckItem>):[],
        ],
        bundleKey: card.type?card.type:'',
      }
      return card_temp
  })
  return cards
}

export default buildCardsData;
